/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import appConfig from 'app-config';
import { useTranslator } from '@jutro/locale';
import { InlineNotification } from '@jutro/components';
import { WizardContext } from '@xengage/gw-portals-wizard-react';
import { MLNotificationBlockContext, MLNotificationBlockUtil, withMLNotificationBlockUtil } from 'ml-portals-util-react'
import { MLTooltipComponent } from 'ml-components-platform-react';
import styles from './MLAlertGroupComponent.module.scss'

import { withViewModelService } from '@xengage/gw-portals-viewmodel-react';

function MLAlertGroupComponent(props){
    const { notificationBlock } = useContext(MLNotificationBlockContext);
    const translator = useTranslator();
    const wizardContext = useContext(WizardContext);
    const isGPA = appConfig.portalCode === 'GPA';
    const isAMP = appConfig.portalCode === 'AMP';
    const isQnB = appConfig.portalCode === 'QB';
    let currentStepId;
    if(!props.noWizard){
        const { currentStep } = wizardContext;
        currentStepId = currentStep.id;
    }
    const {
        clearAlerts
    } = MLNotificationBlockUtil();

    useEffect(() => {
        if(!props.customAlerts){
            isGPA && props.clearOnStepChange && clearAlerts();
            if(!props.noWizard){
                return () => clearAlerts();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStepId])

    const notifications = props.customAlerts || notificationBlock;
    
    if(!notifications || notifications.length === 0){
        return <React.Fragment />
    }

    const getBlockClassName = () => {
        if(props.isAmpPopup){
            return classNames(styles.notificationBlockAmpPopup, props.className)
        }
        if(isQnB) {
            return classNames(styles.notificationBlockQnB, props.className)
        }
        return classNames(isGPA ? styles.notificationBlockGpa : styles.notificationBlock, props.className)
    }

    return(
        <div className={getBlockClassName()}>
            {notifications.map((alert, index) => {
                const id = `inlineNotification${index}`;
                const undo = () => {
                    if(alert.onClick){
                        alert.onClick();
                    }
                }
                let message = translator(alert.message, {
                    strong: (chunks) => <strong>{chunks}</strong>,
                    a: (chunks) => <a key={id} role="button" tabIndex={0} onClick={undo} onKeyDown={undo}>{chunks}</a>,
                    p: (chunks) => <p className={isGPA ? styles.gpaAlertGroupP : styles.alertGroupP}>{chunks}</p>,
                    b: (chunks) => <b className={styles.alertGroupP}>{chunks}</b>,
                    br: () => <br />
                });

                if(alert.alertHelpMessage){
                    message = (
                        <React.Fragment>
                            {message}
                            <MLTooltipComponent 
                                key={id} 
                                tooltipHeader={alert.alertHelpTitle} 
                                tooltipContent={alert.alertHelpMessage}
                                tooltipWrapperClassName={styles.inlineTooltip}
                            />
                        </React.Fragment>
                    );
                }
                if(alert.separatedUndoFunc){
                    message = (
                        <div className={styles.flex}>
                            <span>{message}</span>
                            <span className='padding-left-10'>
                                <a className={styles.wordbreak} key={id} role="button" tabIndex={0} onClick={undo} onKeyDown={undo}>Undo</a>
                            </span>
                        </div>
                    )
                }

                const getLineClassName = () => {
                    if (isGPA) {
                        return classNames(styles.notificationLineGpa, styles[alert.type]);
                    }
                    if (props.isPOPUP) {
                        return classNames(styles.notificationLinePOPUP, styles[alert.type]);
                    }
                    if (props.isAmpPopup) {
                        return classNames(styles.notificationLineGpa, styles[alert.type]);
                    }
                    if (isQnB) {
                        return classNames(styles[`notificationQnB-${alert.type}`]);
                    }
                    return classNames(styles.notificationLine, styles[alert.type]);
                }

                return (
                    <div className={isQnB ? styles.QnBwrapper : styles[`wrapper-${alert.type}`]}>
                        <InlineNotification
                            id={id}
                            key={id}
                            isDismissable={false}
                            className={getLineClassName()}
                            message=<span role="alert" aria-live="polite">{message}</span>
                            messageProps={{
                                dismissLabel: ' ',
                                error: ' ',
                                info: ' ',
                                success: ' ',
                                warning: ' '
                            }}
                            type={alert.type}
                        />
                    </div>
                )
            })}
        </div>
        
    );
}

MLAlertGroupComponent.propTypes = {
    noWizard: PropTypes.bool,
    className: PropTypes.string,
    clearOnStepChange: PropTypes.bool
};
MLAlertGroupComponent.defaultProps = {
    noWizard: false,
    className: undefined,
    clearOnStepChange: true
};

export default withMLNotificationBlockUtil(withViewModelService(MLAlertGroupComponent));